
// pages/Prospectos.jsx
import React from 'react';
import ProspectosList from '../../components/CRM/ProspectosList';

const Prospectos = ({ usuario }) => {
  return <ProspectosList usuario={usuario} />;
};

export default Prospectos;
